import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import ArrowrightIcon from 'icons/Arrowright.icon';

import './DashCardHeading.styles.scss';

type DashCardHeadingProps = {
  className?: string;
  heading: string;
  linkTo: string;
  linkLabel: string;
};

const DashCardHeading: React.FC<DashCardHeadingProps> = (props) => {
  const { className, heading, linkTo, linkLabel } = props;

  const classes = classNames('dash-card-heading', className);

  return (
    <div className={classes}>
      <p>{heading}</p>
      <Link to={linkTo} className="ncoded-button">
        {linkLabel}
        <ArrowrightIcon />
      </Link>
    </div>
  );
};

export default DashCardHeading;
